(function() { window.GUID_4cf03738_003b_4d8d_9379_1fb57d718225 = { getGuid: function() { return "4cf03738-003b-4d8d-9379-1fb57d718225"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PopupWizardStep {
            constructor(wizard) {
                this.Wizard = wizard;
                this.$StepDiv = $("#" + wizard.ControlId + "-step-" + wizard.CurrentStep);
            }
            CheckIfCanContinue(callback) {
                let canContinue = this.OnCheckIfCanContinue();
                this.Wizard.SetNextButtonActive(canContinue);
                this.OnCheckIfCanContinueDone(canContinue);
            }
            OnLoad() { }
            OnPrevious() { }
            OnCheckIfCanContinueDone(canContinue) { }
            OnSubmit() { }
        }
        Controls.PopupWizardStep = PopupWizardStep;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=popup-wizard-step.js.map
